var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from 'src/Utils/api';
var appendToFormData = function (formData, key, value) {
    if (value !== undefined && value !== null && value !== '') {
        formData.append(key, typeof value === 'boolean' ? value.toString() : value);
    }
};
export var createTicket = function (params) {
    var formData = new FormData();
    var requiredFields = {
        'ticket[building_id]': params.building_id,
        'ticket[title]': params.title,
        'ticket[description]': params.description,
        'ticket[provider_service]': params.provider_service,
        'ticket[communication_channel]': params.communication_channel,
        'ticket[internal]': params.internal,
        'ticket[external_client]': params.external_client,
    };
    var optionalFields = {
        'ticket[apartment_id]': params.apartment_id,
        'ticket[assignee_id]': params.assignee_id,
        'ticket[apartment_contact_id]': params.apartment_contact_id,
        'ticket[numeric_client_code]': params.numeric_client_code,
        'ticket[external_client_first_name]': params.external_client_first_name,
        'ticket[external_client_last_name]': params.external_client_last_name,
        'ticket[external_client_phone]': params.external_client_phone,
    };
    Object.entries(__assign(__assign({}, requiredFields), optionalFields)).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        appendToFormData(formData, key, value);
    });
    if (params.new_contact) {
        Object.entries(params.new_contact).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            appendToFormData(formData, "ticket[new_contact][" + key + "]", value);
        });
    }
    return api.post('/tickets', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
